var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-content',{staticClass:"d-flex flex-column justify-around"},[_c('a-empty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }